import {Injectable} from '@angular/core';
import {Base64} from 'js-base64';
@Injectable()
export class Base64Service {
  constructor() {}

  encode(value: string): string {
    return Base64.encode(value);
  }

  decode(value: string): string {
    return Base64.decode(value);
  }

  base64ToBlob(value: string, contentType: string = '', sliceSize: number = 512): Blob {
    const byteCharacters = atob(value);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    return new Blob(byteArrays, {type: contentType});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/base64.service.ts